import styled from 'styled-components';
import { B2C } from '../../style/Typography';

const gap = 32;
const width = 320;
export const CONTROL_WIDTH = `${width}px`;
export const CONTROL_WIDER = `${width * 2 + gap}px`;
export const CONTROL_HEIGHT = '48px';

export const FormContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${`${gap}px`};
`;

export const FieldContainer = styled.div.attrs({ className: 'dsc-fieldControl' })`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--small-gap);
  width: ${({ $width }) => $width || CONTROL_WIDTH};
  .MuiOutlinedInput-root {
    background-color: var(--select-bg-color);
  }
`;

export const Error = styled(B2C)`
  position: absolute;
  bottom: -15px;
  right: 0;
  color: var(--error);
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
